import { Dish } from 'types';

import { useSwitches } from 'features/switches/api/getSwitches';
import { useAnalyzers } from 'features/analyzers/api/getAnalyzers';

export const useGetAnalyzerIdsForDish = () => {
  const { data: switches } = useSwitches({});
  const { data: analyzers } = useAnalyzers({});
  return (dish: Dish) => {
    const analyzerIds: number[] = [];
    for (const analyzerDish of dish.analyzer_dish) {
      const analyzer = analyzers?.find(
        (analyzer) => analyzer.id === analyzerDish.analyzer_id
      );
      if (analyzer) analyzerIds.push(analyzer.id);
      else {
        if (analyzerDish.switch_id) {
          const switchAssociatedWithDish = switches?.find(
            (analyzerSwitch) => analyzerSwitch.id === analyzerDish.switch_id
          );
          if (switchAssociatedWithDish) {
            for (const analyzerSwitch of switchAssociatedWithDish.analyzer_switch) {
              const analyzer = analyzers?.find(
                (analyzer) => analyzer.id === analyzerSwitch.analyzer_id
              );
              if (analyzer) analyzerIds.push(analyzer.id);
            }
          }
        }
      }
    }
    return analyzerIds;
  };
};
